import { Show } from "solid-js";
import type { ParentComponent, JSX, Component } from "solid-js";
import type { IconName } from "../icon/Icon";
import { Icon } from "../icon/Icon";
import Popover from "../popover/Popover";
import { RemoteImage } from "../image/Image";
import { DECORATIVE_IMAGE_ALT } from "../../constants";

export type SplitButtonPropertyProps = {
  ariaLabel: string;
  Title: Component;
  hasError: boolean;
  trigger: {
    ariaLabel?: string;
    label: string;
    resourceId?: string;
    icon?: { name: IconName; class: string };
    hexColour?: JSX.CSSProperties["background"];
  };
  secondaryAction: {
    title: string;
    onClick: () => void;
    icon: IconName;
  };
};

const SplitButtonProperty: ParentComponent<SplitButtonPropertyProps> = (props) => (
  <div class="flex h-9.5 shrink-0 items-center shadow-elevation-light-1">
    <Popover
      positioning={{ placement: "bottom-end" }}
      aria-label={props.ariaLabel}
      variant="md"
      modal
      Title={props.Title}
      Trigger={(arkProps) => (
        <button
          aria-label={props.trigger.ariaLabel}
          type="button"
          class="flex h-9.5 w-full min-w-0 items-center rounded-l border-y border-l bg-button-bg-secondary-default pl-2 text-left hover:bg-button-bg-secondary-hover focus-visible:outline-default active:bg-button-bg-secondary-pressed"
          classList={{ "border-error": props.hasError, "border-button-border-secondary": !props.hasError }}
          {...arkProps}
        >
          <Show when={props.trigger.hexColour}>
            {(hexColour) => <div class="size-6 shrink-0 rounded-sm" style={{ background: hexColour() }} />}
          </Show>
          <Show when={props.trigger.icon}>
            {(icon) => (
              <Icon
                name={icon().name}
                type="solid"
                size="xl"
                classList={{ "shrink-0 rounded-sm": true, [icon().class]: true }}
              />
            )}
          </Show>
          <Show when={props.trigger.resourceId}>
            {(resourceId) => (
              <div class="size-6 shrink-0 rounded-sm">
                <RemoteImage alt={DECORATIVE_IMAGE_ALT} resourceId={resourceId()} cover={false} size="custom" />
              </div>
            )}
          </Show>
          <span class="w-full truncate pr-4 pl-2 text-base-regular text-button-text-secondary-enabled">
            {props.trigger.label}
          </span>
        </button>
      )}
    >
      {props.children}
    </Popover>
    <button
      type="button"
      title={props.secondaryAction.title}
      class="flex size-9.5 items-center justify-center rounded-r border bg-button-bg-secondary-default px-3 hover:bg-button-bg-secondary-hover focus-visible:outline-default active:bg-button-bg-secondary-pressed"
      classList={{
        "border-error border-l-button-border-secondary": props.hasError,
        "border-button-border-secondary": !props.hasError,
      }}
      onClick={() => props.secondaryAction.onClick()}
    >
      <Icon
        name={props.secondaryAction.icon}
        size="sm"
        type="solid"
        class="shrink-0 icon-button-icon-secondary-default"
      />
    </button>
  </div>
);

export default SplitButtonProperty;
